import { GetSmoothTwoToneGradient } from "./GetTwoToneGradient";

export function GetWeatherBkgColor(icon: string, summary: string) {
    if (summary.includes(`Smoke`)) {
        return GetSmoothTwoToneGradient(`#63323a`, `#291923`);
    }

    if (summary.includes(`Mostly Cloudy`)) {
        return GetSmoothTwoToneGradient(`#718096`, `#39465e`);
    }

    const dictionary = new Map();

    dictionary.set(
        `clear-day`,
        GetSmoothTwoToneGradient(`#3bc8fa`, `#147fc7`)
    );

    dictionary.set(
        `clear-night`,
        GetSmoothTwoToneGradient(`#352a91`, `#10173f`, 135)
    );

    dictionary.set(`rain`, GetSmoothTwoToneGradient(`#557da8`, `#243d68`));
    dictionary.set(`snow`, GetSmoothTwoToneGradient(`#aaa5da`, `#62689d`));
    dictionary.set(`sleet`, GetSmoothTwoToneGradient(`#74518f`, `#3e275d`));
    dictionary.set(
        `wind`,
        GetSmoothTwoToneGradient(`#b39d48`, `#665b27`)
    );
    dictionary.set(`fog`, GetSmoothTwoToneGradient(`#55708f`, `#293e5c`));
    dictionary.set(`cloudy`, GetSmoothTwoToneGradient(`#707c8b`, `#3e4856`));

    dictionary.set(
        `partly-cloudy-day`,
        GetSmoothTwoToneGradient(`#6da7d7`, `#3265a9`)
    );

    dictionary.set(
        `partly-cloudy-night`,
        GetSmoothTwoToneGradient(`#625d91`, `#292752`)
    );

    if (dictionary.has(icon)) {
        return dictionary.get(icon);
    } else {
        return `black`;
    }
}
